import MainPage from "./lucky-draw";
import LuckyDrawDetailPage from "./lucky-draw-detail";
import LiveDrawPage from "./live-draw"
import LuckyDrawParticipants from "./lucky-draw-participants";
export { MainPage, LuckyDrawDetailPage, LiveDrawPage, LuckyDrawParticipants };
